<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/alt-text -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="input" *ngIf="type === 'text'">
  <label>
    {{ label }} <span *ngIf="requiredInput" class="required">*</span>
  </label>
  <input
    type="text"
    [placeholder]="placeholder"
    [attr.maxLength]="maxLength"
    [style.width]="width"
    [readOnly]="readOnly"
    [disabled]="disabled"
    [attr.id]="name"
    [mask]="mask"
    [(ngModel)]="value"
    #myInputField="ngModel"
    (ngModelChange)="onValueChange($event)"
    (focus)="onFocus()"
    (blur)="onBlur()"
    [required]="requiredInput"
    [ngClass]="{
      invalid:
        myInputField.invalid && (myInputField.dirty || myInputField.touched)
    }" />
  <div
    *ngIf="myInputField.invalid && (myInputField.dirty || myInputField.touched)"
    class="error-message">
    Campo obrigatório!
  </div>
</div>

<div class="input" *ngIf="type === 'only-text'">
  <label>
    {{ label }} <span *ngIf="requiredInput" class="required">*</span>
  </label>
  <input
    type="text"
    [placeholder]="placeholder"
    [attr.maxLength]="maxLength"
    [style.width]="width"
    [readOnly]="readOnly"
    [(ngModel)]="value"
    #myInputField="ngModel"
    (ngModelChange)="onValueChange($event)"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (keydown)="applyMask($event)"
    [required]="requiredInput"
    [ngClass]="{
      invalid:
        myInputField.invalid && (myInputField.dirty || myInputField.touched)
    }" />
  <div
    *ngIf="myInputField.invalid && (myInputField.dirty || myInputField.touched)"
    class="error-message">
    Campo obrigatório!
  </div>
</div>

<div class="input" *ngIf="type === 'disabled'">
  <label
    >{{ label }} <span *ngIf="requiredInput" class="required">*</span></label
  >
  <input
    type="text"
    [placeholder]="placeholder"
    [attr.maxLength]="maxLength"
    [style.width]="width"
    [readOnly]="true"
    [disabled]="true"
    [mask]="mask"
    class="disabled"
    [(ngModel)]="value"
    (ngModelChange)="onValueChange($event)" />
</div>

<div class="input" *ngIf="type === 'password'">
  <label
    >{{ label }} <span *ngIf="requiredInput" class="required">*</span></label
  >
  <input
    [type]="passwordType"
    [placeholder]="placeholder"
    [attr.maxLength]="maxLength"
    [style.width]="width"
    [attr.disabled]="disabled"
    [readOnly]="readOnly"
    [mask]="mask"
    [(ngModel)]="value"
    (ngModelChange)="onValueChange($event)" />
  <img (click)="togglePassword()" [src]="eyeImage" class="eye" />
</div>

<div class="input" *ngIf="type === 'email'">
  <label>
    {{ label }} <span *ngIf="requiredInput" class="required">*</span>
  </label>
  <input
    type="email"
    [placeholder]="placeholder"
    [attr.maxLength]="maxLength"
    [style.width]="width"
    [attr.disabled]="disabled"
    [readOnly]="readOnly"
    [(ngModel)]="value"
    #myInputField="ngModel"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (ngModelChange)="onValueChange($event)"
    [ngClass]="{
      invalid:
        myInputField.invalid && (myInputField.dirty || myInputField.touched)
    }"
    [required]="requiredInput && value" />
  <div
    *ngIf="myInputField.invalid && (myInputField.dirty || myInputField.touched)"
    class="error-message">
    <span *ngIf="myInputField.errors?.['required']">Campo obrigatório!</span>
    <span *ngIf="myInputField.errors?.['email']">E-mail inválido!</span>
  </div>
</div>

<div class="input" *ngIf="type === 'money'">
  <label
    >{{ label }} <span *ngIf="requiredInput" class="required">*</span></label
  >
  <input
    [placeholder]="placeholder"
    [attr.maxLength]="maxLength"
    [style.width]="width"
    [readOnly]="readOnly"
    [(ngModel)]="value"
    [disabled]="disabled"
    [currencyMask]="{
      prefix: 'R$ ',
      thousands: '.',
      decimal: ',',
      align: 'left'
    }"
    (ngModelChange)="onValueChange($event)" />
</div>

<div class="input" *ngIf="type === 'date'">
  <label
    >{{ label }} <span *ngIf="requiredInput" class="required">*</span></label
  >
  <input
    type="date"
    [placeholder]="placeholder"
    [(ngModel)]="value"
    [mask]="mask"
    [style.width]="width"
    (ngModelChange)="onValueChange($event)" />
</div>

<div class="input" *ngIf="type === 'month'">
  <label
    >{{ label }} <span *ngIf="requiredInput" class="required">*</span></label
  >
  <input
    type="month"
    [placeholder]="placeholder"
    [(ngModel)]="value"
    [mask]="mask"
    [style.width]="width"
    (ngModelChange)="onValueChange($event)" />
</div>

<div class="input" *ngIf="type === 'datetime-local'">
  <label
    >{{ label }} <span *ngIf="requiredInput" class="required">*</span></label
  >
  <input
    type="datetime-local"
    [placeholder]="placeholder"
    [(ngModel)]="value"
    [mask]="mask"
    [disabled]="disabled"
    (ngModelChange)="onValueChange($event)" />
</div>

<div class="input" *ngIf="type === 'number'">
  <label>
    {{ label }} <span *ngIf="requiredInput" class="required">*</span>
  </label>
  <input
    type="number"
    [placeholder]="placeholder"
    [attr.maxLength]="maxLength"
    [style.width]="width"
    [readOnly]="readOnly"
    [(ngModel)]="value"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (ngModelChange)="onValueChange($event)"
    [attr.min]="min"
    [attr.max]="max"
    [required]="requiredInput" />
</div>

<div class="input" *ngIf="type === 'textarea'">
  <label
    >{{ label }} <span *ngIf="requiredInput" class="required">*</span></label
  >
  <textarea
    [placeholder]="placeholder"
    [attr.maxLength]="maxLength"
    [style.width]="width"
    [readOnly]="readOnly"
    [attr.disabled]="disabled"
    [mask]="mask"
    [(ngModel)]="value"
    (ngModelChange)="onValueChange($event)"></textarea>
</div>

<div class="input" *ngIf="type === 'select'">
  <label
    >{{ label }} <span *ngIf="requiredInput" class="required">*</span></label
  >
  <select
    [style.width]="width"
    [(ngModel)]="value"
    (ngModelChange)="onSelectChange($event)"
    [disabled]="disabled">
    <option value="">Selecione</option>
    <option *ngFor="let data of selectData" [value]="data.value">
      {{ data.name }}
    </option>
  </select>
</div>

<div class="input" *ngIf="type === 'select-table'">
  <label
    >{{ label }} <span *ngIf="requiredInput" class="required">*</span></label
  >
  <select
    [style.width]="width"
    [(ngModel)]="value"
    (ngModelChange)="onSelectChange($event)"
    [disabled]="disabled">
    <option *ngFor="let data of selectData" [value]="data.value">
      {{ data.name }}
    </option>
  </select>
</div>

<div class="input" *ngIf="type === 'search'">
  <label
    >{{ label }} <span *ngIf="requiredInput" class="required">*</span></label
  >
  <div class="search-container">
    <img src="assets/filter.png" class="search-icon" />
    <input
      class="search-input"
      name="pesquisar"
      type="text"
      [placeholder]="placeholder"
      [style.width]="width"
      [mask]="mask"
      [(ngModel)]="value"
      (ngModelChange)="onValueChange($event)" />
  </div>
</div>
